/**
 * Cashier Add Card SC View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var core = require('core');
    var PortletView = require('modules/portlet/portlet.view');
    var AddCardModel = require('portlets/cashier/addcard-sc/addcard.model');
    var payment = require('common/payment.util');
    var urlUtil = require('util/url.util');
    var storage = require('util/storage.util');
    var cashierUtil = require('modules/cashier/cashier.util');
    var config = require('config');
    var postMessageManager = require('managers/postMessage.manager.instance');
    var user = require('user');
    var utils = require('utils');
    var scrollManager = require('managers/scroll.manager');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        options: {
            showBorders: true
        },

        tKeyPrefix: 'playtech.mobile.system.mobile-cashier',

        cardTitle: function() {
            return this.translate(this.tKeyPrefix + '.add-card-sc.title');
        },

        className: 'add-card-sc',

        initialize: function(options) {
            this.options = options;
            this.model = new AddCardModel({
                tokenProvider: options.addViaVco ? 'visacheckout' : 'safecharge'
            });

            PortletView.prototype.initialize.apply(this, arguments);
        },

        subscribe: function() {
            this.listenTo(this.model, 'change:headerParameters', this.handleHeaderParams);
        },

        initPostMessages: function() {
            this.postMessageHandlerId = postMessageManager.addHandler({
                source: this.$('.fn-add-card-sc-iframe')[0].contentWindow,
                callback: this.handlePostMessage.bind(this),
                parse: true
            });
        },

        destroyPostMessages: function() {
            if (this.postMessageHandlerId) {
                postMessageManager.removeHandler(this.postMessageHandlerId);
            }
        },

        handlePostMessage: function(message, parseError) {
            if (parseError) {
                core.warn('Message from Add Card Iframe can\'t be parsed:', message);
                return;
            }

            var urlParams = urlUtil.getURLParams(message.href);

            if (urlParams.type === 'addcard') {
                this.handleAddCardStatus(urlParams);
            }
        },

        handleAddCardStatus: function(urlParams) {
            var tKey = this.tKeyPrefix + '.notifications.addCardScStatus';

            this.back();

            ['error', 'cancel'].includes(urlParams.status)
            && this.showInfo({ content: this.translate(tKey + utils.capitalize(urlParams.status)) });

            urlParams.status === 'success'
            && this.addCardSuccess(urlParams);
        },

        handleHeaderParams: function() {
            var params = this.model.get('headerParameters');

            if (!params.url || !Object.keys(params.postData).length) {
                core.warn('Header parameters do not contain all data:', params);
                return this.renderError();
            }

            this.options.addViaVco ? this.submitForm() : this.renderToIframe();
        },

        /**
         * @deprecated 18.9.0
         */
        _postMessageHandler: function() {
            core.warn('`_postMessageHandler` is deprecated since version 18.9.0. ' +
                'The new method is `handlePostMessage`.');
        },

        /**
         * @deprecated 18.9.0
         */
        _getMerchantDataSuccess: function() {
            core.warn('`_getMerchantDataSuccess` is deprecated since version 18.9.0. ' +
                'Code was split between `submitForm` and `renderToIframe`');
        },

        /**
         * @deprecated 18.9.0
         */
        _getMerchantDataFail: function() {
            core.warn('`_getMerchantDataFail` is deprecated since version 18.9.0.' +
                'The new method is `renderError`.');
        },

        renderError: function(response) {
            var message = cashierUtil.getErrorMessage(response)
                || utils.fromPath(response, 'data.errorMessage');
            var options = message
                ? { message: message }
                : { tKey: 'playtech.mobile.system.sc-cashier.message.somethingWentWrong' };

            this.$el.html(this.tmpl('common.portletError', options));
        },

        submitForm: function(options) {
            var form = payment.createFormWithHeaderParameters(
                this.model.get('headerParameters'),
                { theme_id: '0'}
            );

            // Dynamic load form in specified window
            form.setAttribute('target', options && options.target || '_self');
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },

        renderToIframe: function() {
            if (!document.contains(this.el)) {
                return;
            }

            this.$el.html(this.tmpl('addcard-sc'));
            this.submitForm({ target: 'addCardScIframe' });
            this.initPostMessages();
        },

        render: function() {
            var urlParams = urlUtil.getURLParams();

            this.$el.html(this.tmpl('common.loader'));

            if (urlParams.status) {
                this.handleAddCardStatus(urlParams);
                return this;
            }

            this.model.fetch().fail(this.renderError.bind(this));
            return this;
        },

        portletDidMount: function() {
            // continue register for fast registered players
            if (user.isFastRegistered()) {
                return user.continueRegistration();
            }
        },

        addCardSuccess: function(response) {
            if (response.accountCode && response.accountId && response.methodCode) {
                this.showInfo({
                    content: this.translate(this.tKeyPrefix + '.notifications.cardAdded')
                });

                storage.session.setItem('lastAddedPayment', response.methodCode);

                response = this.model.formatAddedPaymentAccount(response);
                core.trigger('card:added', response, this.options);
            } else {
                this.showInfo({
                    content: this.translate(this.tKeyPrefix + '.notifications.addCardScStatusSuccessButInvalidResponse')
                });
            }
        },

        back: function() {
            var backUrl = urlUtil.getLocationParameterByName('back_url');
            var depositPage = config.get('depositPage');
            var rootPage = config.get('rootPage');
            var targetPage;

            // check if origin is safe
            var backUrlOrigin = new URL(backUrl, location.origin).origin;
            var safeOriginsCfg = this.options.config.safeOrigins || '';
            var safeOrigins = safeOriginsCfg
                .split('\n')
                .filter(origin => !_.isEmpty(origin))
                .concat([location.origin]);

            if (!safeOrigins.includes(backUrlOrigin)) {
                backUrl = null;
            }

            targetPage = backUrl || depositPage || rootPage;

            core.navigate(targetPage);
        },

        close: function() {
            PortletView.prototype.close.apply(this, arguments);

            this.destroyPostMessages();

            // When SC closed, can't focus on input field on device (issue MCS-242)
            $('body').append('<input type="text" style="width:1px; height:1px;" />');
            $('input[type=text]')[0].focus();
            this.hideKeyboard();
            $('input[type=text]').remove();

            scrollManager.scrollTo(0);

            window.Playtech.API.common.replace(urlUtil.pathname, undefined, { removeParams: ['back_url'] });
            core.trigger('backButton:show');
        }
    });
});
